// extracted by mini-css-extract-plugin
export default {"userInfos":"UserInfos_userInfos__WQSof"};